var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 17,
    viewBox: "0 0 56 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.6195 5.13315C54.9342 5.13315 56 4.06735 56 2.75261C56 1.43787 54.9342 0.37207 53.6195 0.37207C52.3047 0.37207 51.2389 1.43787 51.2389 2.75261C51.2389 4.06735 52.3047 5.13315 53.6195 5.13315Z",
    fill: "#2D2D2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.319 8.94957H38.2054C38.2959 11.9629 40.1654 13.6502 42.8159 13.6502C44.9853 13.6502 46.462 12.3546 46.8537 10.6069H50.1983C49.7161 14.4336 46.2811 16.5129 42.8159 16.5129C37.9042 16.5129 34.68 13.6804 34.68 8.19693C34.68 3.13373 37.844 0 42.635 0C47.395 0 50.319 3.46525 50.319 7.74418V8.94957ZM38.2054 6.87031H46.7031C46.5225 4.36937 44.9254 2.8627 42.4846 2.8627C40.1943 2.8627 38.3872 4.21873 38.2054 6.87031Z",
    fill: "#2D2D2D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5074 10.9684H22.1233C22.2437 12.8065 23.6594 13.8319 26.1612 13.8319C28.2102 13.8319 29.4758 13.0787 29.4758 11.8131C29.4758 10.8788 28.9334 10.3666 27.3363 10.0052L23.4189 9.16041C20.5864 8.58809 18.8689 7.11194 18.8689 4.75996C18.8689 1.86703 21.4905 0 25.6488 0C30.199 0 32.8809 2.04902 32.8809 5.54396H29.3551C29.3551 3.76597 28.0293 2.68126 25.7695 2.68126C23.7204 2.68126 22.4848 3.43473 22.4848 4.66924C22.4848 5.51288 23.208 6.17591 24.5039 6.47719L28.6019 7.35106C31.6452 8.0141 33.1219 9.33905 33.1219 11.6599C33.1219 14.7035 30.5306 16.5115 26.1309 16.5115C21.3399 16.5129 18.6278 14.524 18.5074 10.9684Z",
    fill: "#2D2D2D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3775 0.239746H16.0536V16.0294H12.3775V0.239746Z",
    fill: "#2D2D2D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.79677 6.41706C4.48976 1.89705 6.08687 0.239746 10.426 0.239746V3.34352C5.57447 3.6448 3.76653 5.18171 3.67609 9.91255V16.0294H0V0.480824H3.55597L3.67637 6.41678L3.79677 6.41706Z",
    fill: "#2D2D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAlt);
export default __webpack_public_path__ + "static/media/logo-alt.0d2441049d5d6231d2defe7bb4388046.svg";
export { ForwardRef as ReactComponent };